<template>
  <div class="input-group mb-3" v-if="to!=undefined">
    <div class="input-group-prepend">
      <span class="input-group-text">To</span>
    </div>
    <input type="text" class="form-control" @input="updateTo"  :value="to" placeholder="@channelusername or @groupusername or user_id">
  </div>
</template>


<script>
export default {
  name: 'To',
  props: {
    to: String
  },
  methods: {
    updateTo: function(event){
      this.$emit('updateTo', event.target.value);
    }
  },
}
</script>
